import React from 'react';
import Proptypes from 'prop-types';
import {
  Block,
} from 'components/common';
import TestimonialPane from './TestimonialPane';

import './TestimonialsPanel.scss';

const TestimonialsPanel = ({ heading, testimonial }) => (
  <div className="testimonial-panel">
    {testimonial && (
      <Block>
        <Block.Header
          title={heading}
        />
        <div className="container-wrapper">
          <div className="row-wrapper">
            <div className="testimonial-pane-wrapper">
              <TestimonialPane testimonials={testimonial} />
            </div>
          </div>
        </div>
      </Block>
    )}
  </div>
);

TestimonialsPanel.propTypes = {
  testimonial: Proptypes.arrayOf(Proptypes.shape({
    image: Proptypes.shape({
      title: Proptypes.string.isRequired,
      url: Proptypes.string.isRequired,
    }).isRequired,
    imageAlt: Proptypes.string.isRequired,
    quote: Proptypes.string.isRequired,
  })).isRequired,
  heading: Proptypes.string,
};

TestimonialsPanel.defaultProps = {
  heading: '',
};

export default TestimonialsPanel;
